import React from "react"
import {Grid, Stack, Typography} from "@mui/material";

export default function Footer() {
    return (
        <Grid item xs={12} sx={{ mt: 10 }}>
            <Stack spacing={1} direction={"row"} justifyContent={"flex-end"} sx={{ px: 3}}>
                <Typography variant={"body2"} fontSize={10}>
                    Powered By
                </Typography>
                <img
                    alt={'logo unitag.io'}
                    src={'/unitag-logo-hd.png'}
                    height={"15px"}
                    width={"auto"}
                    style={{ marginTop: "-0px" }}
                />
            </Stack>
        </Grid>
    )
}